import { RevealBox, SectionLabel, SectionTitle } from './UI';

const rows = [
  { feature: 'UGC-Approved Degrees', igrade: true, traditional: true, others: false },
  { feature: 'Free Expert Counselling', igrade: true, traditional: false, others: false },
  { feature: 'Admission in 3–7 Days', igrade: true, traditional: false, others: false },
  { feature: 'NAAC A++ Universities', igrade: true, traditional: false, others: '⚠️ Few' },
  { feature: 'Dedicated Support Post-Enrolment', igrade: true, traditional: false, others: false },
  { feature: '100% Online & Flexible', igrade: true, traditional: false, others: true },
  { feature: 'EMI / Loan Assistance', igrade: true, traditional: false, others: '⚠️ Limited' },
  { feature: 'Multiple University Options', igrade: true, traditional: false, others: false },
  { feature: 'PAN-India Reach', igrade: true, traditional: false, others: true },
  { feature: 'Zero Hidden Charges', igrade: true, traditional: '⚠️ Varies', others: '⚠️ Varies' },
  { feature: 'Document Handling by Team', igrade: true, traditional: false, others: false },
  { feature: 'Govt. Job Eligible Degrees', igrade: true, traditional: true, others: '⚠️ Some' },
];

const Cell = ({ value }) => {
  if (value === true) return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div style={{
        width: 28, height: 28, borderRadius: '50%',
        background: 'rgba(34,197,94,0.12)', display: 'grid', placeItems: 'center',
      }}>
        <span style={{ color: '#16a34a', fontSize: 15, fontWeight: 800 }}>✓</span>
      </div>
    </div>
  );
  if (value === false) return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div style={{
        width: 28, height: 28, borderRadius: '50%',
        background: 'rgba(239,68,68,0.1)', display: 'grid', placeItems: 'center',
      }}>
        <span style={{ color: '#dc2626', fontSize: 15, fontWeight: 800 }}>✕</span>
      </div>
    </div>
  );
  return <div style={{ textAlign: 'center', fontSize: 13, color: 'var(--gray)', fontWeight: 600 }}>{value}</div>;
};

export default function ComparisonTable() {
  return (
    <section id="compare" style={{ padding: '100px 6%', background: 'var(--white)' }}>
      <RevealBox style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto 56px' }}>
        <SectionLabel>Why iGrade Wins</SectionLabel>
        <SectionTitle style={{ maxWidth: '100%', textAlign: 'center' }}>
          iGrade vs <em style={{ fontStyle: 'italic' }}>The Alternatives</em>
        </SectionTitle>
        <p style={{ fontSize: 17, color: 'var(--gray)', marginTop: 14, lineHeight: 1.7 }}>
          See exactly why 15,000+ students chose iGrade over traditional colleges and other platforms.
        </p>
      </RevealBox>

      <RevealBox>
        <div style={{ overflowX: 'auto', borderRadius: 20, boxShadow: 'var(--shadow-lg)', border: '1.5px solid var(--graylt)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 600 }}>
            <thead>
              <tr>
                <th style={{
                  padding: '24px 28px', textAlign: 'left', background: 'var(--offwhite)',
                  fontSize: 13, fontWeight: 700, color: 'var(--gray)', letterSpacing: '1px',
                  textTransform: 'uppercase', borderBottom: '2px solid var(--graylt)',
                  width: '40%',
                }}>Feature</th>

                {/* iGrade column — highlighted */}
                <th style={{
                  padding: '24px 20px', textAlign: 'center', background: 'var(--navy)',
                  borderBottom: '2px solid var(--navy2)', position: 'relative',
                }}>
                  <div style={{
                    position: 'absolute', top: -1, left: 0, right: 0,
                    height: 4, background: 'var(--yellow)', borderRadius: '0 0 0 0',
                  }} />
                  <div style={{ fontSize: 11, color: 'var(--yellow)', fontWeight: 800, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: 6 }}>⭐ Recommended</div>
                  <div style={{ fontSize: 18, color: '#fff', fontFamily: 'Playfair Display,serif', fontWeight: 700 }}>iGrade Education</div>
                </th>

                <th style={{
                  padding: '24px 20px', textAlign: 'center', background: 'var(--offwhite)',
                  borderBottom: '2px solid var(--graylt)',
                }}>
                  <div style={{ fontSize: 11, color: 'var(--gray)', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 6 }}>Old School</div>
                  <div style={{ fontSize: 16, color: 'var(--navy)', fontFamily: 'Playfair Display,serif', fontWeight: 700 }}>Traditional College</div>
                </th>

                <th style={{
                  padding: '24px 20px', textAlign: 'center', background: 'var(--offwhite)',
                  borderBottom: '2px solid var(--graylt)',
                }}>
                  <div style={{ fontSize: 11, color: 'var(--gray)', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 6 }}>Generic</div>
                  <div style={{ fontSize: 16, color: 'var(--navy)', fontFamily: 'Playfair Display,serif', fontWeight: 700 }}>Other EdTech</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.feature} style={{ background: i % 2 === 0 ? '#fff' : 'var(--offwhite)' }}>
                  <td style={{
                    padding: '16px 28px', fontSize: 15, fontWeight: 600,
                    color: 'var(--navy3)', borderBottom: '1px solid var(--graylt)',
                  }}>{row.feature}</td>

                  {/* iGrade cell — highlighted */}
                  <td style={{
                    padding: '16px 20px', background: i % 2 === 0 ? 'rgba(11,31,74,0.04)' : 'rgba(11,31,74,0.06)',
                    borderBottom: '1px solid rgba(11,31,74,0.08)',
                    borderLeft: '1px solid rgba(11,31,74,0.1)',
                    borderRight: '1px solid rgba(11,31,74,0.1)',
                  }}>
                    <Cell value={row.igrade} />
                  </td>

                  <td style={{ padding: '16px 20px', borderBottom: '1px solid var(--graylt)' }}>
                    <Cell value={row.traditional} />
                  </td>

                  <td style={{ padding: '16px 20px', borderBottom: '1px solid var(--graylt)' }}>
                    <Cell value={row.others} />
                  </td>
                </tr>
              ))}
            </tbody>

            {/* Footer CTA row */}
            <tfoot>
              <tr>
                <td style={{ padding: '24px 28px', background: 'var(--offwhite)', fontSize: 14, fontWeight: 700, color: 'var(--navy)' }}>
                  Ready to choose the best?
                </td>
                <td style={{ padding: '20px', background: 'rgba(11,31,74,0.06)', borderLeft: '1px solid rgba(11,31,74,0.1)', borderRight: '1px solid rgba(11,31,74,0.1)' }}>
                  <a href="#contact" style={{
                    display: 'block', textAlign: 'center',
                    background: 'var(--yellow)', color: 'var(--navy)',
                    padding: '12px 16px', borderRadius: 8, fontWeight: 800, fontSize: 14,
                    transition: 'all 0.2s',
                  }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'var(--yellow2)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'var(--yellow)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                  >Get Started →</a>
                </td>
                <td style={{ padding: '20px', background: 'var(--offwhite)', textAlign: 'center' }}>
                  <span style={{ fontSize: 13, color: 'var(--gray)' }}>Limited flexibility</span>
                </td>
                <td style={{ padding: '20px', background: 'var(--offwhite)', textAlign: 'center' }}>
                  <span style={{ fontSize: 13, color: 'var(--gray)' }}>No guidance</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </RevealBox>
    </section>
  );
}
